import React, { ReactNode } from 'react';
import { X, Plus } from 'lucide-react';
import { Sheet, SheetContent } from '../../../../components/ui/sheet';
import { Button } from '../../../../components/ui/button';

interface PammDrawerFormProps {
  open: boolean;
  onClose: () => void;
  title: string;
  onSubmit: (e: React.FormEvent) => void;
  loading?: boolean;
  submitText?: string;
  children: ReactNode;
}

export function PammDrawerForm({
  open,
  onClose,
  title,
  onSubmit,
  loading = false,
  submitText = 'Add',
  children,
}: PammDrawerFormProps) {
  return (
    <Sheet open={open} onOpenChange={openState => !openState && onClose()}>
      <SheetContent
        side="right"
        className="w-full max-w-md p-0 overflow-hidden flex flex-col bg-background border-l border-border"
        showClose={false}
      >
        <div className="px-6 py-4 border-b border-border flex items-center justify-between bg-card">
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-1.5 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors focus:outline-none"
            aria-label="Close drawer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Scrollable Form Body */}
        <form
          onSubmit={onSubmit}
          className="flex-1 flex flex-col justify-between overflow-y-auto bg-background"
        >
          <div className="bg-card  p-2 space-y-3 text-card-foreground">
            {children}
          </div>

          <div className="px-6 py-4 border-t border-border flex items-center justify-end gap-3 bg-card">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="flex items-center gap-1.5"
            >
              <Plus className="w-4 h-4" />
              {loading ? 'Processing...' : submitText}
            </Button>
          </div>
        </form>
      </SheetContent>
    </Sheet>
  );
}

export default PammDrawerForm;
